// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1cA_q","bigColWidth":"Table_bigColWidth__1Zl_O","biggerColWidth":"Table_biggerColWidth__1QX3K","row":"Table_row__6kKfa","col":"Table_col__2f-vY"};